module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-sk-8e1b47f75a8b0e1d4c6ac4b94cf99c33.svg";